<template>
  <div class="content">
    <div class="content_title">
      Детальная участка
    </div>
    <div class="tabs-container">
      <div class="tabs-header">
        <button
          v-for="tab in tabs"
          v-bind:key="tab.component"
          v-bind:class="[
            'tab-button',
            { active: currentTab === tab.component }
          ]"
          v-on:click="currentTab = tab.component"
        >
          {{ tab.title }}
        </button>
      </div>
    </div>
    <keep-alive>
      <component v-bind:is="currentTabComponent" class="tab"></component>
    </keep-alive>
  </div>
</template>

<script>
import config from "@/config";
import tabData from "components/map/plotTabs/tabData";
import tabDocuments from "components/map/plotTabs/tabDocuments";
import tabAuto from "components/map/plotTabs/tabAuto";
import tabEvents from "components/map/plotTabs/tabEvents";
import tabFaces from "components/map/plotTabs/tabFaces";
import tabFinance from "components/map/plotTabs/tabFinance";
import tabPass from "components/map/plotTabs/tabPass";

export default {
  name: "PlotDetail",
  components: {
    tabData,
    tabDocuments,
    tabAuto,
    tabEvents,
    tabFaces,
    tabFinance,
    tabPass
  },
  data() {
    return {
      currentTab: "Data",
      tabs: [
        {
          component: "Data",
          title: "Данные участка"
        },
        {
          component: "Documents",
          title: "Документы"
        },
        {
          component: "Faces",
          title: "Лица"
        },
        {
          component: "Pass",
          title: "Пропуска"
        },
        {
          component: "Auto",
          title: "Авто"
        },
        {
          component: "Events",
          title: "События"
        },
        {
          component: "Finance",
          title: "Финансы"
        }
      ],
      id: this.$route.params.id,
      url: config.backend_url
    };
  },
  computed: {
    currentTabComponent: function() {
      return "tab-" + this.currentTab.toLowerCase();
    }
  },
  watch: {},
  methods: {},
  created() {}
};
</script>
